import React, { useCallback, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { ModalWrapper } from '@/core/modal';
import BatchDownloadTab from '@/features/downloadMedia/downloadSidebar/batchDownload/BatchDownloadTab';
import { ImageSelectorMedia } from '@/services/editorService';
import { bulkMediaListState, downloadMediaState } from '@/stores/mediaStore';

export default function DownloadSidebar({ id, ...rest }: { id: string }) {
  const mediasToDownload = useRecoilValue(downloadMediaState);
  const bulkMediaList = useRecoilValue(bulkMediaListState);

  const [shouldShowDownloadTab, setShouldShowDownloadTab] = useState(
    mediasToDownload.length === 1
  );
  const [selectedMediaForInfo, setSelectedMediaForInfo] = useState(
    mediasToDownload[0]
  );

  const onThumbnailClick = useCallback((mediaForInfo: ImageSelectorMedia) => {
    setSelectedMediaForInfo(mediaForInfo);
    setShouldShowDownloadTab(true);
  }, []);

  const onBackButtonClicked = useCallback(
    () => setShouldShowDownloadTab(false),
    []
  );

  return (
    <ModalWrapper
      className="text-start w-60 bg-gray-450 mb-auto ms-auto mt-16 me-8 p-6 rounded-2xl"
      {...rest}
    >
      <BatchDownloadTab
        modalId={id}
        onThumbnailClick={onThumbnailClick}
        onBackButtonClicked={onBackButtonClicked}
        shouldShowDownloadTab={shouldShowDownloadTab}
        selectedMediaForInfo={
          bulkMediaList.length === 1
            ? mediasToDownload[0]
            : selectedMediaForInfo
        }
      />
      )
    </ModalWrapper>
  );
}
